import Component from '@glimmer/component'
import type { ItemReference } from 'teacher-ui-client/components/reporting/map-selector/item'
import { MapSelectorItem } from 'teacher-ui-client/components/reporting/map-selector/item'

interface Args {
  title?: string
  itemReferences: ItemReference[]
  currentItemId?: number
  changeItem?: (id: number) => void
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export class ReportingMapSelector extends Component<Signature> {
  get itemReferences() {
    return this.args.itemReferences ?? []
  }
  <template>
    <div data-test-map-selector class="text-center print:hidden" ...attributes>
      <div class="border-dusty-black-100 mx-auto mt-1 mb-3 inline-flex w-auto items-center rounded-sm border pl-5">
        <span class="pr-5">{{@title}}</span>
        {{#each @itemReferences as |item|}}
          <MapSelectorItem @item={{item}} @currentItemId={{@currentItemId}} @changeItem={{@changeItem}} />
        {{/each}}
      </div>
    </div>
  </template>
}

export default ReportingMapSelector
